module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab6/awsop-lab6.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab6/awsop-lab6.component.css
// module chunks = main